// Skip Link Component for Accessibility
// Allows keyboard users to skip navigation and go directly to main content

const SkipLink = () => {
  return (
    <a 
      href="#main-content" 
      className="skip-link"
      data-testid="skip-link"
    >
      Skip to main content
    </a>
  );
};

export default SkipLink;
